import React, { useState } from "react";
import { FaUpload, FaEye, FaTimes, FaFilePdf } from "react-icons/fa";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { cssProperties } from "../utils/commonCssProperties";


const FileUploader = ({ Filename, fileUrl, handleUpload, handleRemoveFile }) => {
  const [file, setFile] = useState(null);
  // const [fileUrl, setFileUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // const handleUpload = (event) => {
  //   const uploadedFile = event.target.files[0];
  //   if (uploadedFile) {
  //     setFile(uploadedFile);
  //     setFileUrl(URL.createObjectURL(uploadedFile));
  //   }
  // };

  const handleViewSample = () => {
    console.log('fileUrl--',fileUrl);
    
    if (fileUrl) {
      setShowModal(true);
    } else {
      alert("There is no sample provided for the current file");
    }
  };

  // const handleRemoveFile = () => {
  //   setFile(null);
  //   setFileUrl(null);
  // };

  return (
    <>
      <Dialog
        open={showModal}
        maxWidth="xl"
        PaperProps={{sx:{width:'100%'}}}
        onClose={() => setShowModal(false)}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          File Preview
          <IoIosCloseCircleOutline onClick={() => setShowModal(false)} size={16} style={{ cursor: "pointer" }} />

        </DialogTitle>

        <DialogContent sx={{ height: "80vh",width:'100%' }}>
          <iframe
            src={fileUrl}
            title="PDF Preview"
            style={{ width: "100%", height: "100%" }}
          />
        </DialogContent>
      </Dialog>
      <div style={{ marginTop: "5px" }}>
        <div
          style={{
            border: `1px solid ${cssProperties?.color?.primary}`,
            
            borderRadius: "8px",
            padding: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <strong>{Filename}</strong>
          </div>

          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <label
              style={{
                backgroundColor: "#eef2ff",
                color: `${cssProperties?.color?.primary}`,
                border: "none",
                borderRadius: "20px",
                padding: "8px 12px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                cursor: "pointer",
              }}
            >
              <FaUpload size={14} /> Upload Template
              <input
                type="file"
                accept="application/pdf"
                onChange={handleUpload}
                style={{ display: "none" }}
              />
            </label>

            <button
              onClick={handleViewSample}
              style={{
                backgroundColor: "#eef2ff",
                color:`${cssProperties?.color?.primary}`,
                border: "none",
                borderRadius: "20px",
                padding: "8px 12px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                cursor: "pointer",
              }}
            >
              <FaEye size={14} /> View Sample
            </button>

            {fileUrl && (
              <div
                style={{
                  backgroundColor: "#f3f4f6",
                  
                  padding: "6px 10px",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <FaFilePdf />
                <span style={{ fontSize: "14px" }}>{Filename}</span>
                <FaTimes
                  style={{ cursor: "pointer" }}
                  onClick={handleRemoveFile}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FileUploader;
